module.exports = __webpack_public_path__ + "img/icon_flag_us.c107371e.png";